module.exports = __webpack_public_path__ + "static/media/angel.85c546a7.svg";